import type { QueryClient } from '@tanstack/react-query';
import { invalidateItemListQueries } from '@/lib/hooks/items/invalidateItemListQueries';
import { workIntegrationsQueryKeys } from '@/lib/query-keys/work-integrations';

export const invalidateAfterItemSyncMutation = (queryClient: QueryClient) => {
  invalidateItemListQueries(queryClient);
  queryClient.invalidateQueries({
    queryKey: workIntegrationsQueryKeys.itemSyncStatusesPrefix(),
  });
  queryClient.invalidateQueries({
    queryKey: workIntegrationsQueryKeys.workIntegrationItemsPrefix(),
  });
};
